module.exports = __webpack_public_path__ + "img/vlf.b79daa29.webp";